module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start cotacao-manual-main-container"
  }, [_c('div', {
    staticClass: "column start-centered cotacao-manual-anexo-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Anexos da Cotação:")]), _vm._v(" "), (!_vm.carregandoAnexos) ? _c('uploadCotacaoManualVisualizacao', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.anexos,
      "localUso": "COTACAO_MANUAL",
      "maxFiles": 3,
      "disable": this.visualizacao
    }
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  }), _vm._v("\n            Carregando Anexos...\n          ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-415ebe2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/visualizacaoDocumentosCotacao.vue
// module id = 1930
// module chunks = 1